import * as Sentry from "@sentry/vue";

export function localStoragePersistSafely(key: string, value?: string): boolean {
    try {
        if (value) {
            localStorage.setItem(key, value); // Attempt to store the key-value pair safely
        } else {
            localStorage.removeItem(key)
        }
        return true; // Return true if successful
    } catch (e) {
        if (e instanceof DOMException && e.name === "QuotaExceededError") { // Check if it's a QuotaExceededError
            const storageInfo = getLocalStorageInfo(); // Collect storage diagnostics

            // Sentry.captureMessage(`QuotaExceededError while storing key: ${key}`, {
            //     level: "warning",
            //     extra: {key, error: e, storageInfo}
            // });

            if (storageInfo.itemCount > 100) { //Clear locale storage
                localStorage.clear();
            }
        } else {
            Sentry.captureException(e); // Log any other errors to Sentry
        }
        return false; // Return false if an error occurred
    }
}

// Function to measure storage capacity and usage
export function getLocalStorageInfo(): Record<string, any> {
    let totalCapacity = 0;
    const MAX_CAPACITY_TEST = 5 * 1024 * 1024; // Maximum capacity test limit (5MB)
    const usedBytes = new Blob(Object.values(localStorage)).size;

    // Measure remaining capacity by filling up localStorage within the 5MB limit
    try {
        const testKey = "__test_key__";
        const testValue = "x".repeat(1024); // A 1KB test value
        while (totalCapacity + testValue.length <= MAX_CAPACITY_TEST) { // Ensure max-test limit is not exceeded
            localStorage.setItem(testKey + totalCapacity, testValue);
            totalCapacity += testValue.length;
        }
    } catch (e) {
        // Clear the test data after calculating
        Object.keys(localStorage)
            .filter((key) => key.startsWith("__test_key__"))
            .forEach((key) => localStorage.removeItem(key));
    }

    return {
        totalCapacity: totalCapacity + usedBytes, // Approx max capacity
        usedBytes,
        remainingBytes: totalCapacity, // Estimated remaining capacity
        itemCount: localStorage.length, // Number of items in localStorage
    };
}
